import forms from "./forms";
import list from "./list";
import templates from "./templates";

export default { ...list, forms, templates };
